import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Lucía', 'Diego', 'Ana', 'Fernando', 'Gabriela', 'Javier', 'Sofía', 'Martín'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Salta', 'Mar del Plata'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first notification
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerNotification = () => {
    // Randomize data
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotificationData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification (random interval between 8-12 seconds)
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(triggerNotification, nextInterval);
    }, 4000);
  };
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-lg border border-blue-100 p-4 flex items-center gap-3" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-3">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-gray-900" data-id="element-6">
              {notificationData.name} de {notificationData.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-7">
              acaba de comprar{' '}
              <span className="font-semibold text-blue-600" data-id="element-8">
                Física Sencilla
              </span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}